import Base from '../Base';
export default class Stationnements extends Base {
    init(id, main, locale) {
        console.log(':: Stationnements ::');

        var els = document.getElementsByClassName('tableContainer');

        Array.from(els).forEach(el => {
            el.addEventListener('scroll', () => {
                el.classList.add('scrollTable');
            });
        });
    }
}